import React, { useEffect, useState } from "react";
import Headernav from "../header_nav/Headernav";
import "./dashboardadmins.scss";
import Add_members from "../Members_func/Add_members";
import axios from "axios";
import { API_BASE } from "../apiBase";
import { useLocation } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";

let Dashboard_super_admin = () => {
    const [logs, setLogs] = useState([]);
    const [logsLoading, setLogsLoading] = useState(false);
    const [logsError, setLogsError] = useState("");
    const userRole = localStorage.getItem("user_role") || "";
    const isSuperAdmin = userRole === "super_admin";
    const location = useLocation();
    const showHistoryOnly = location.hash === "#audit-history";
    const columns = [
        { field: "created_at", headerName: "Date", minWidth: 160, flex: 1 },
        { field: "event_type", headerName: "Event", minWidth: 150, flex: 1 },
        { field: "username", headerName: "User", minWidth: 160, flex: 1 },
        { field: "user_role", headerName: "Role", minWidth: 120, flex: 0.6 },
        { field: "target_username", headerName: "Target", minWidth: 160, flex: 1 },
        { field: "member_no", headerName: "Member", minWidth: 90, flex: 0.5 },
        {
            field: "details",
            headerName: "Details",
            minWidth: 240,
            flex: 2,
            renderCell: (params) => (
                <div className="audit-log-cell">{params.value || "-"}</div>
            ),
        },
    ];

    const fetchLogs = () => {
        setLogsLoading(true);
        setLogsError("");
        axios
            .get(`${API_BASE}/audit_logs.php?limit=200`)
            .then((response) => {
                setLogs(Array.isArray(response.data) ? response.data : []);
            })
            .catch(() => {
                setLogs([]);
                setLogsError("Unable to load audit history.");
            })
            .finally(() => setLogsLoading(false));
    };

    useEffect(() => {
        if (isSuperAdmin) {
            fetchLogs();
        }
    }, [isSuperAdmin]);

    useEffect(() => {
        if (location.hash === "#audit-history") {
            const target = document.getElementById("audit-history");
            if (target) {
                target.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    }, [location.hash]);

    return (
        <div>
            <Headernav />
            {isSuperAdmin ? (
                <>
                    {!showHistoryOnly && <Add_members />}
                    <div className="audit-log-section" id="audit-history">
                        <div className="audit-log-header">
                            <h3>Audit History</h3>
                            <button type="button" onClick={fetchLogs} className="audit-log-refresh">
                                Refresh
                            </button>
                        </div>
                        {logsLoading && <div className="audit-log-status">Loading...</div>}
                        {logsError && <div className="audit-log-error">{logsError}</div>}
                        {!logsLoading && !logsError && logs.length === 0 && (
                            <div className="audit-log-empty">No audit entries found.</div>
                        )}
                        {!logsLoading && logs.length > 0 && (
                            <div className="audit-log-grid">
                                <DataGrid
                                    rows={logs}
                                    columns={columns}
                                    getRowHeight={() => "auto"}
                                    disableRowSelectionOnClick
                                    pageSizeOptions={[10, 25, 50]}
                                    initialState={{
                                        pagination: { paginationModel: { pageSize: 10 } },
                                    }}
                                    sx={{
                                        "& .MuiDataGrid-cell": {
                                            whiteSpace: "normal",
                                            lineHeight: "1.4",
                                            alignItems: "flex-start",
                                            py: 1,
                                        },
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </>
            ) : (
                <div className="audit-log-denied">Access denied.</div>
            )}
        </div>
    );
};

export default Dashboard_super_admin;
